import React from 'react'

const InfoIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 23 23" fill="none">
                <path
                    d="M22.944 10.875C22.568 7.178 20.361 4.021 17.244 2.328C16.932 2.158 16.612 2.004 16.282 1.864C15.295 1.447 14.235 1.17 13.125 1.056C12.755 1.019 12.38 1 12 1C11.621 1 11.246 1.019 10.875 1.056C9.766 1.17 8.705 1.447 7.719 1.864C7.389 2.004 7.069 2.158 6.757 2.328C3.64 4.021 1.433 7.178 1.057 10.875C1.02 11.245 1 11.62 1 12C1 18.075 5.925 23 12 23C18.076 23 23 18.075 23 12C23 11.62 22.981 11.245 22.944 10.875Z"
                    fill="#496EBD"
                />
                <path
                    d="M12.0994 8.2C12.6504 8.2 13.0994 7.75 13.0994 7.2V7C13.0994 6.45 12.6504 6 12.0994 6H11.9004C11.3494 6 10.9004 6.45 10.9004 7V7.2C10.9004 7.75 11.3494 8.2 11.9004 8.2H12.0994ZM12.2994 18C12.6854 18 12.9994 17.685 12.9994 17.3V10.7C12.9994 10.315 12.6854 10 12.2994 10H11.7004C11.3144 10 10.9994 10.315 10.9994 10.7V17.3C10.9994 17.685 11.3144 18 11.7004 18H12.2994Z"
                    fill="white"
                />
        </svg>
    )
}

export default InfoIcon
